// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zE18","title":"styles_title__3QI2M"};